import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { from } from 'rxjs';

export class WebpackTranslateLoader implements TranslateLoader {
  public getTranslation(lang: string): Observable<Record<string, string>> {
    return from(import(`../../../assets/i18n/${lang}.json`));
  }
}